import { FileUploadOrDownload, Session } from "./types";

function getUnifiedUrisFromSession<T extends FileUploadOrDownload>(
	session: Session<T> | null,
): string[] {
	if (!session) {
		return [];
	}

	return session.items.reduce<string[]>((acc, val) => {
		if (val.unifiedUri) {
			acc.push(val.unifiedUri);
		}

		return acc;
	}, []);
}

export const SessionUtils = {
	from: getUnifiedUrisFromSession,
};
